package com.ervasstudio.tracoemovimento.components.custumcomponents.layout

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res
import com.ervasstudio.tracoemovimento.util.Res.Image.dropdown
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*


@Composable
fun MenuPerfil(
    anchorId: String = "menu-perfil-anchor",
    nome: String? = "Fromel",
    estado: String = "activo",
    onClick: () -> Unit = {},
    isMobile: Boolean,
) {
    val roxo = Color.rgb(0x7B6CAD)

    Row(
        modifier = Modifier
            .id(anchorId) // Define o elemento de ancoragem para o MdMenu
            .backgroundColor(roxo)
            .borderRadius(999.px)
            .padding(leftRight = if (isMobile) 6.px else 10.px, topBottom = if (isMobile) 5.px else 8.px)
            .gap(if (isMobile) 6.px else 14.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Avatar
        Image(
            src = Res.Image.user,
            alt = "User",
            modifier = Modifier.width(if (isMobile) 20.px else 42.px)
        )

        Column(verticalArrangement = Arrangement.spacedBy(if (isMobile) 2.px else 4.px)) {
            if(!isMobile){
                if (nome != null) {
                    SpanText(
                        nome,
                        Modifier
                            .fontFamily("museomoderno")
                            .fontWeight(FontWeight.Bold)
                            .fontSize(if (isMobile) 10.px else 20.px)
                            .color(Colors.White)
                    )
                }
            }

            Row(verticalAlignment = Alignment.CenterVertically) {
                SpanText(
                    estado,
                    Modifier
                        .fontFamily("GothamBook")
                        .fontSize(if (isMobile) 8.px else 15.px)
                        .color(Colors.White)
                        .margin(right = 8.px)
                )
                Box(
                    modifier = Modifier
                        .size(if (isMobile) 6.px else 12.px)
                        .borderRadius(if (isMobile) 22.percent else 50.percent)
                        .backgroundColor(Color.rgb(0x5DBB4B))
                )
            }
        }

        if(!isMobile){
            Image(
                src = dropdown,
                alt = "DropDown",
                modifier = Modifier.width(if (isMobile) 18.px else 32.px)
            )
        }
        // Seta de dropdown

    }
}